/**
 * Configurações do Umami Analytics
 * 
 * Este arquivo centraliza todas as configurações relacionadas ao analytics
 * Facilita a gestão de múltiplos sites e ambientes
 */

// URLs do Umami para diferentes ambientes
export const UMAMI_CONFIG = {
  // URL do seu servidor Umami
  SCRIPT_URL: 'https://analytics.aytech.online/script.js',
  
  // Website IDs para diferentes sites/ambientes
  WEBSITE_IDS: {
    // Site principal da AyTech
    AYTECH_MAIN: 'a78a4a94-446a-4db4-8a9e-c8d969981bb6',
    
    // Outros sites que você pode adicionar no futuro
    AYTECH_BLOG: '',
    AYTECH_LOJA: '',
    AYTECH_LANDING: '',
    
    // Ambiente de desenvolvimento
    DEVELOPMENT: 'dev-website-id'
  },
  
  // Configurações gerais
  SETTINGS: {
    AUTO_TRACK: true,
    DO_NOT_TRACK: true,
    CACHE: true,
    HONOR_DNT: true, // Respeitar Do Not Track do browser
    DOMAINS: [
      'aytech.online',
      'www.aytech.online',
      'localhost' // Para desenvolvimento
    ]
  }
};

// Função para obter o Website ID baseado no ambiente/domínio
export const getWebsiteId = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  
  // Ambiente de desenvolvimento
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return UMAMI_CONFIG.WEBSITE_IDS.DEVELOPMENT;
  }
  
  // Produção - site principal
  if (hostname.includes('aytech.com.br')) {
    return UMAMI_CONFIG.WEBSITE_IDS.AYTECH_MAIN;
  }
  
  // Blog (exemplo para futuro)
  if (hostname.includes('blog.aytech.com.br')) {
    return UMAMI_CONFIG.WEBSITE_IDS.AYTECH_BLOG;
  }
  
  // Loja (exemplo para futuro)
  if (hostname.includes('loja.aytech.com.br')) {
    return UMAMI_CONFIG.WEBSITE_IDS.AYTECH_LOJA;
  }
  
  // Default para o site principal
  return UMAMI_CONFIG.WEBSITE_IDS.AYTECH_MAIN;
};

// Função para verificar se o analytics deve ser carregado
export const shouldLoadAnalytics = () => {
  // Não carregar em desenvolvimento se não configurado
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_ENABLE_ANALYTICS === 'true';
  }
  
  // Sempre carregar em produção
  return process.env.NODE_ENV === 'production';
};

// Eventos padrão para tracking
export const ANALYTICS_EVENTS = {
  // Navegação
  NAVIGATION: 'navigation',
  PAGE_VIEW: 'page_view',
  
  // Interações com serviços
  SERVICE_CLICK: 'service_click',
  SERVICE_VIEW: 'service_view',
  
  // Contato e conversões
  WHATSAPP_CLICK: 'whatsapp_click',
  FORM_SUBMIT: 'form_submit',
  CONTACT_CLICK: 'contact_click',
  
  // Downloads e recursos
  DOWNLOAD: 'download',
  EXTERNAL_LINK: 'external_link',
  
  
  // Engajamento
  SCROLL_DEPTH: 'scroll_depth',
  TIME_ON_PAGE: 'time_on_page',
  
  // Erros e performance
  ERROR: 'error',
  PERFORMANCE: 'performance'
};

// Configurações de scroll tracking
export const SCROLL_TRACKING = {
  ENABLED: true,
  THRESHOLDS: [25, 50, 75, 90, 100], // Porcentagens para tracking
  DEBOUNCE_TIME: 1000 // ms para evitar spam
};

// Configurações de debug
export const DEBUG_CONFIG = {
  ENABLED: process.env.NODE_ENV === 'development',
  LOG_EVENTS: true,
  LOG_PAGE_VIEWS: true,
  CONSOLE_PREFIX: '📊 Analytics:'
};

export default UMAMI_CONFIG;